import { useMemo } from 'react'
import { deepMerge } from '@codeleap/utils'
import { useMessageContext } from 'stream-chat-react'
import { AnyRecord, ICSS } from '@codeleap/styles'

type Value = AnyRecord

type StylesShape<K extends string, V extends Value> = Partial<
  Record<K, ICSS & Partial<Omit<V, keyof ICSS>>>
>

export const useConditionalMessageStyle = <
  K extends string,
  V extends Value = {},
>(
    baseStyle: StylesShape<K, V>,
    myMessageStyle: Record<string, ICSS & Partial<Omit<V, keyof ICSS>>>,
  ) => {
  const context = useMessageContext()
  const isMyMessage = context.isMyMessage()

  const styles = useMemo(
    () => (isMyMessage ? deepMerge(baseStyle, myMessageStyle) : baseStyle),
    [isMyMessage, baseStyle, myMessageStyle],
  ) as StylesShape<K, V>

  return { styles }
}
